import { VolumeControls } from '@tmsw/powerups.audio.components.volume-controls';
import { OptionsMenu } from '@tmsw/powerups.ui.dialogs.settings';
import { GameControls as GameControlsPanel } from '../components/panels/GameControls';
import { AccessibilitySettings as AccessibilitySettingsPanel } from '../components/panels/AccessibilitySettings';
import { HowToPlay as HowToPlayPanel } from '../components/panels/HowToPlay';

export const SettingsPanelConfig = {
  root: {
    name: 'OptionsMenu',
    variant: 'panel',
    heading: { localeKey: 'openSettingsPanel', ns: 'SETTINGS_PANEL' },
    component: OptionsMenu,
    options: {},
    items: [
      {
        name: 'AccessibilitySettings',
        variant: 'panel',
        heading: { localeKey: 'accessibilitySettings', ns: 'SETTINGS_PANEL' },
        underline: true,
        component: AccessibilitySettingsPanel,
      },
      {
        name: 'GameControls',
        variant: 'panel',
        heading: { localeKey: 'gameControls', ns: 'SETTINGS_PANEL' },
        underline: true,
        component: GameControlsPanel,
      },
      {
        name: 'VolumeControls',
        variant: 'widget',
        heading: { localeKey: 'volumeSetting', ns: 'SETTINGS_PANEL' },
        component: VolumeControls,
      },
      {
        name: 'HappyMealHome',
        variant: 'link',
        heading: { localeKey: 'returnToHappyMealDotCom', ns: 'SETTINGS_PANEL' },
        href: { localeKey: 'buttons.hmHome.url', ns: 'GENERAL' },
        underline: true,
        shouldRender: (props: any) => props.returnToHappyMealDotCom !== '',
      },
      {
        name: 'AppHome',
        heading: { localeKey: 'appHome', ns: 'SETTINGS_PANEL' },
        variant: 'goto',
        targetPage: 0,
        underline: true,
      },
      {
        name: 'ChangeCharacter',
        heading: { localeKey: 'selectCharacter', ns: 'SETTINGS_PANEL' },
        variant: 'goto',
        targetPage: 'CHARACTER_SELECTION',
        underline: true,
      },
      {
        name: 'CameraAccess',
        heading: { localeKey: 'cameraAccess', ns: 'SETTINGS_PANEL' },
        variant: 'goto',
        targetPage: 'CAMERA_ACCESS',
        underline: true,
        shouldRender: (props: any) =>
          !document.querySelector('main.market--mea'),
      },
      {
        name: 'HowToPlay',
        variant: 'panel',
        heading: { localeKey: 'howToPlay', ns: 'SETTINGS_PANEL' },
        underline: true,
        component: HowToPlayPanel,
      },
    ],
  },
};

export const componentConfig = {
  CircleButton: {
    defaultVariant: 'gradient',
    defaultColor: 'primary',
    defaultSize: 'md',
  },
  SettingsPanel: SettingsPanelConfig,
};
